import type { NavigateFunction } from 'react-router-dom'

/**
 * Torna al punto da cui si e' arrivati, conservandone il contesto.
 *
 * Il dettaglio di una scheda si apre da dodici punti diversi — lista schede,
 * Lavori in officina, board giornaliero, dashboard, calendario, calendario
 * preventivi... — e ognuno ha il suo stato: il filtro della lista, il giorno
 * del board, la settimana del calendario. Un percorso fisso li perde tutti.
 *
 * `navigate(-1)` li conserva perche' torna alla voce di cronologia precedente,
 * querystring compresa.
 *
 * Il fallback serve a chi non ha una pagina precedente: link aperto in una
 * scheda nuova, segnalibro, ricarica. React Router tiene l'indice della voce
 * corrente in `history.state.idx`: se e' 0 (o assente) indietro non porterebbe
 * da nessuna parte e si va alla lista schede, senza filtri.
 */
export function tornaIndietro(navigate: NavigateFunction, fallback = '/schede-lavoro'): void {
  const idx = (window.history.state as { idx?: number } | null)?.idx
  if (typeof idx === 'number' && idx > 0) navigate(-1)
  else navigate(fallback, { replace: true })
}
